import { Upload, Space, Typography } from 'antd';
import styled from 'styled-components';

export const UploadContainer = styled(Upload)`
    margin-left: 10px;
`;

export const ContentContainer = styled(Space)`
    width: 100%;
    justify-content: center;
`;
export const ButtonContainer = styled(ContentContainer)`
    margin-top: 16px;
`;

export const StyledTypography = styled(Typography)`
    text-align: center;
`;
